import { Form } from "antd";
import React from "react";
import { TitleBar } from "./Model";

const InputViews = (props) => {
  const { info } = props;
  return (
    <div className="components-input-views">
      <TitleBar info={info}></TitleBar>
      {info.titleTip && <div className="tips-bar">{info.titleTip}</div>}
      <Form.Item name={["postAnswer", info.position]}>
        {/* <Input.TextArea rows={info.height} placeholder={info.translation?.textAreaTip}></Input.TextArea> */}
        <textarea rows={info.height} placeholder={info.translation?.textAreaTip}></textarea>
      </Form.Item>
    </div>
  );
};

export default InputViews;
